export const fileTypesIcons = {
  document: 'fa-file-pdf-o',
  web: 'fa-cloud',
}
